export default {
  SET_SUMMARY(state, data) {
    state.summary = data ? { ...data } : null;
  },

  SET_LOADING(state, value) {
    state.loading = value;
  }
};
